<!-- <div mat-dialog-title style="padding: 10px; color: #FFF; background-color:#1579ab;">
    <div class="d-flex justify-content-between">
        Fill the details to Link Document
        <i class="fa fa-times-circle pull-right" style="font-size: 24px;" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div> -->

<div mat-dialog-title style="padding: 10px; color: #FFF; background-color:#1579ab;">
    <div class="d-flex justify-content-between">
      <p>Fill the details to Link Document</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" style="cursor: pointer;" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
  </div>


<!-- <div mat-dialog-content>
    <div class="row m-0">
        <div class="col-12 p-0">
            <dynamic-form #docSetForm [repeatCount]=4></dynamic-form>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <EIPAutoComplete TextField="group_Name" ValueField="group_Id" WaterMarkText="Approval By *" formControlName="formApprovalBy" setId="ddlApprovalbyId" ShowTextValueField='N' [dataSource]='projBusinessGroups' [IsCascading]='true' (valueChange)='selectedApprovalby($event)' [SingleValueBind]="false">
            </EIPAutoComplete>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <EIPAutoComplete TextField="workflowName" ValueField="workflowId" WaterMarkText="Workflow" setId="workflowId" ShowTextValueField='N' [dataSource]='workflowList' formControlName="formWorkflow" [IsCascading]='true' [defaultValue]="selectedWorkflownumber" (valueChange)='selectedworkflowvalue($event)' (click)="closeworkflowTab($event)">
            </EIPAutoComplete>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <EIPAutoComplete TextField="dedDescription" ValueField="dedId" WaterMarkText="Released For *" formControlName="formDciStatus" required setId="releasedforId" ShowTextValueField='N' [dataSource]='dciStatusList' [IsCascading]='true' (valueChange)='selectedReleasedfor($event)'>
            </EIPAutoComplete>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <button id="postBtnId" class="btn btn-primary" (click)="postElementdetails()">Link</button> 
        </div>
    </div>
</div> -->

<div mat-dialog-content class="m-0">
    <div class="eip-mxy-5">
        <mat-accordion>
            <mat-expansion-panel [expanded]="true">
                <div class="eip-mt-20 eip-mb-10">
                    <div class="row m-0">
                        <div class="col-12 p-0">
                            <dynamic-form #docSetForm [repeatCount]=4></dynamic-form>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <EIPAutoComplete TextField="group_Name" ValueField="group_Id" WaterMarkText="Approval By *" formControlName="formApprovalBy" setId="ddlApprovalbyId" ShowTextValueField='N' [dataSource]='projBusinessGroups' [IsCascading]='true' (valueChange)='selectedApprovalby($event)' [SingleValueBind]="false">
                            </EIPAutoComplete>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <EIPAutoComplete TextField="workflowName" ValueField="workflowId" WaterMarkText="Workflow" setId="workflowId" ShowTextValueField='N' [dataSource]='workflowList' formControlName="formWorkflow" [IsCascading]='true' [defaultValue]="selectedWorkflownumber" (valueChange)='selectedworkflowvalue($event)' (click)="closeworkflowTab($event)">
                            </EIPAutoComplete>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <EIPAutoComplete TextField="dedDescription" ValueField="dedId" WaterMarkText="Released For *" formControlName="formDciStatus" required setId="releasedforId" ShowTextValueField='N' [dataSource]='dciStatusList' [IsCascading]='true' (valueChange)='selectedReleasedfor($event)'>
                            </EIPAutoComplete>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: end;">
                            <button id="postBtnId" class="btn btn-primary" (click)="postElementdetails()">Link</button> 
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>




